export interface IDeliveryZonesConfig {
  endpoint: string
  region: string
  tag: string
}

export const deliveryZones: IDeliveryZonesConfig = {
  endpoint: process.env.REACT_APP_DELIVERY_ZONES_API_ENDPOINT || 'https://delivery-zones.ext.youfoodz.engineering/delivery-days',
  region: 'CF',
  tag: 'Group: Specialty'
}
